import { useEffect, useRef, useState } from "react";

export function useReveal() {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add("in-view");
          observer.unobserve(el);
        }
      },
      { threshold: 0.12 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  return ref;
}

export function useCountdown(targetIso) {
  const [time, setTime] = useState(() => calc(targetIso));
  useEffect(() => {
    setTime(calc(targetIso));
    if (!targetIso) return;
    const id = setInterval(() => setTime(calc(targetIso)), 1000);
    return () => clearInterval(id);
  }, [targetIso]);
  return time;
}

function calc(iso) {
  const now = new Date().getTime();
  const target = new Date(iso).getTime();
  let diff = Math.max(0, target - now);
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  diff -= days * 24 * 60 * 60 * 1000;
  const hours = Math.floor(diff / (1000 * 60 * 60));
  diff -= hours * 60 * 60 * 1000;
  const minutes = Math.floor(diff / (1000 * 60));
  diff -= minutes * 60 * 1000;
  const seconds = Math.floor(diff / 1000);
  return { days, hours, minutes, seconds };
}
